var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2083 39.2076L39.2083 43.2076C39.0206 43.3952 38.7661 43.5006 38.5008 43.5006C38.2354 43.5006 37.9809 43.3952 37.7933 43.2076C37.6056 43.0199 37.5002 42.7654 37.5002 42.5001C37.5002 42.2347 37.6056 41.9802 37.7933 41.7926L40.087 39.5001H22.5008C22.2356 39.5001 21.9812 39.3947 21.7937 39.2072C21.6061 39.0196 21.5008 38.7653 21.5008 38.5001C21.5008 38.2349 21.6061 37.9805 21.7937 37.793C21.9812 37.6054 22.2356 37.5001 22.5008 37.5001H40.087L37.7933 35.2076C37.6056 35.0199 37.5002 34.7654 37.5002 34.5001C37.5002 34.2347 37.6056 33.9802 37.7933 33.7926C37.9809 33.6049 38.2354 33.4995 38.5008 33.4995C38.7661 33.4995 39.0206 33.6049 39.2083 33.7926L43.2083 37.7926C43.3013 37.8854 43.375 37.9957 43.4253 38.1171C43.4757 38.2385 43.5016 38.3687 43.5016 38.5001C43.5016 38.6315 43.4757 38.7616 43.4253 38.883C43.375 39.0044 43.3013 39.1147 43.2083 39.2076ZM25.7933 31.2076C25.9809 31.3952 26.2354 31.5006 26.5008 31.5006C26.7662 31.5006 27.0206 31.3952 27.2083 31.2076C27.3959 31.0199 27.5013 30.7654 27.5013 30.5001C27.5013 30.2347 27.3959 29.9802 27.2083 29.7926L24.9145 27.5001H42.5008C42.766 27.5001 43.0204 27.3947 43.2079 27.2072C43.3954 27.0196 43.5008 26.7653 43.5008 26.5001C43.5008 26.2349 43.3954 25.9805 43.2079 25.793C43.0204 25.6054 42.766 25.5001 42.5008 25.5001H24.9145L27.2083 23.2076C27.3959 23.0199 27.5013 22.7654 27.5013 22.5001C27.5013 22.2347 27.3959 21.9802 27.2083 21.7926C27.0206 21.6049 26.7662 21.4995 26.5008 21.4995C26.2354 21.4995 25.9809 21.6049 25.7933 21.7926L21.7933 25.7926C21.7003 25.8854 21.6266 25.9957 21.5762 26.1171C21.5259 26.2385 21.5 26.3687 21.5 26.5001C21.5 26.6315 21.5259 26.7616 21.5762 26.883C21.6266 27.0044 21.7003 27.1147 21.7933 27.2076L25.7933 31.2076Z",
    fill: "#1F2124"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DDE0E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnTransfer);
export default __webpack_public_path__ + "static/media/UnTransfer.2da0ca77228a04940825cbc839d7147b.svg";
export { ForwardRef as ReactComponent };